import React from "react";
import SearchBox from "../1_atoms/SearchBox";
import SelectionBox from "../1_atoms/SelectionBox";

function SearchAndSelection() {
  return (
    <div>
      <SearchBox />
      <SelectionBox />
    </div>
  );
}

export default SearchAndSelection;
